export default __webpack_public_path__ + "static/part1-screenshot-7e36900f5349487f049843d303662cf7.png";